var $ = require('jquery');
require('../vendors/match-height/match-height');

var MatchHeight = function MatchHeight() {
	var $twoColumnBlocks = $('.two-column-text .block');
	if($twoColumnBlocks.length) {
		$twoColumnBlocks.matchHeight();
	}

	var $newsBlocks = $('.latest-news .item');
	if($newsBlocks.length) {
		$newsBlocks.matchHeight();
	}

	var $ctas = $('.call-to-actions .cta');
	if($ctas.length) {
		$ctas.matchHeight();
	}

	var $amenities = $('.amenities .amenity');
	if($amenities.length) {
		$amenities.matchHeight();
	}
}

module.exports = MatchHeight;